import NoPermission from './NoPermission';

export default NoPermission;
